import { combineReducers } from 'redux';
import filters from '../customize/reducers/filters_reducer';
import featured from '../customize/reducers/featured_reducer';
import modals from '../customize/reducers/modal_reducer';
import { tag, pdpModal } from '../generic/global_state/reducers';
import { reducer as favoritesReducer } from '../../../../components/SaveRecipes/favorites.reducer';

export default combineReducers({
  favorites: favoritesReducer,
  filters,
  featured,
  modals,
  tag,
  pdpModal,
});
